module.exports = __webpack_public_path__ + "media/images/riders/small/LINDA_INDERGAND-23ca0b2982347d414b851910bd3c3062.png";